export enum InvoiceTerm {
    OnReceipt = 1,
    Net10 = 2,
    Net30 = 3,
    Net45 = 4
}
